
import { defineComponent,ref } from 'vue'
import PageContent from '@/components/page-content'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/use-page-search'
import PageSearch from '@/components/page-search/src/page-search.vue'

import {
  getParentReservationInfo
} from '@/service/main/system/system'
import { ElNotification } from 'element-plus'
import { searchFormConfig } from './config/search.config'

export default defineComponent({
  name: 'parent',
  components: {
    PageContent,
    PageSearch
  },
  setup() {
    const [pageContentRef, handleResetClick, handleQueryClick] = usePageSearch()
    const dialogVisible = ref(false)
    const data = ref([])
    const otherParams = ref({})
    const getReservationInfo = (userId:number)=>{
      getParentReservationInfo('/pc/userInfo/getAppointmentInfo',{
        userId,
        pageNum:1,
        pageSize:99
      }).then(res=>{
        if(!res.data.rows.length){
          ElNotification(({
            title:'暂无预约信息',
            type:'info'
          }))
        }else{
          data.value = res.data.rows
          dialogVisible.value = true
        }
        console.log(res)
      })
    }

    return {
      contentTableConfig,
      getReservationInfo,
      dialogVisible,
      data,
      searchFormConfig,
      handleResetClick,
      handleQueryClick,
      otherParams,
      pageContentRef
    }
  }
})
